import React, { useEffect, useState } from "react";
import { Switch } from 'antd';
import DatePicker from "react-datepicker";
import pt from "date-fns/locale/pt-BR";
import Plot from 'react-plotly.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-datepicker/dist/react-datepicker.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Search from "@material-ui/icons/Search";
import Icon from "@material-ui/core/Icon";
import Pagination from '@material-ui/lab/Pagination';
import { Collapse, Typography, Box } from '@mui/material';
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import styles2 from "assets/jss/material-dashboard-react/components/headerLinksStyle.js";
import Button from "components/CustomButtons/Button.js";
import CardIcon from "components/Card/CardIcon.js";
import CardFooter from "components/Card/CardFooter.js";
import TableSell from "components/TableSell/TableSell"
import api from "assets/services/api.js";
import useAuth from "hooks/useAuth";
import ModalAddSell from "components/ModalAddSell/ModalAddSell";
const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  colorCard: {
    color: "#999"
  },
  floatRight: {
    float: "right"
  },
  maxwidht: {
    maxWidth: "107%"
  },
  toogleclass: {
    marginTop: "14px",
    marginBottom: "14px",
    width: "65%",
  },
  backGreen: {
    backgroundColor: "#4caf50"
  },
  backRed: {
    backgroundColor: "rgb(244 67 54 / 1)"
  },
  zindex: {
    zIndex: "0 !important"
  },
  marginDate: {
    marginTop: "12px",
    marginBottom: "12px"
  }
};


const useStyles = makeStyles(styles);
const useStyles2 = makeStyles(styles2);


export default function SellNoFiscal() {

  Date.prototype.withoutTime = function () {
    var d = new Date(this);
    d.setHours(0, 0, 0, 0);
    return d;
  };
  const { storageId, garlicType, storageUserType } = useAuth();
  const classes = useStyles();
  const classes2 = useStyles2();
  // data bd
  const [sells, setSells] = useState([]);
  const [totalRemaining, setTotalRemaining] = useState(0);
  const [remainingMonths, setRemainingMonths] = useState([]);
  // params
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [search, setSearch] = useState("");
  const [toogle, setToggle] = useState(false);
  const [toogleCancel, setToggleCancel] = useState(false);
  const [toogle2, setToggle2] = useState(false);
  const [remaining, setRemaining] = useState(false);
  // pagination
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  //modals
  const [modalShow, setModalShow] = useState(false);
  const [importModal, setImportModal] = useState(false);
  // controllers page
  const [expanded, setExpanded] = useState(false);
  console.log(totalRemaining, typeof totalRemaining)

  useEffect(() => {
    loadSell();
    loadPaymentSellReport();
  }, []);

  useEffect(() => {
    loadSell();
  }, [page, startDate, endDate, toogle, toogle2, toogleCancel, garlicType, remaining]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      loadSell();
    }, 900);

    return () => clearTimeout(delayDebounceFn)
  }, [search]);


  const toogler = () => {
    toogle ? setToggle(false) : setToggle(true);
  }
  const toogler2 = () => {
    setRemaining(!remaining);
  }
  const tooglerCancel = () => {
    toogleCancel ? setToggleCancel(false) : setToggleCancel(true);
  }
  const handleChange = (event, value) => {
    setPage(value);
  };

  const alterModal = () => {
    setImportModal(true);
  }

  const callModalAddSell = () => {
    if (!modalShow) {
      alterModal();
    };
    setModalShow(true);
  }

  async function loadSell() {
    const data = await api.get(`/sell/view/${storageId}?noFiscal=true&page=${page}&type=${storageUserType}&date_init=${startDate}&date_end=${endDate}&control=${toogle}&search=${search}&remove=${toogle2}&cancel=${toogleCancel}&garlic=${garlicType}&remaining=${remaining}`);
    setSells(data.data.sells);
    setTotalPages(data.data.totalPages);
  };
  async function loadPaymentSellReport() {
    const data = await api.get(`/payment/sell/report/total/${storageId}`);
    console.log(data.data)
    setTotalRemaining(parseFloat(data.data.total_remaining));
    const obj_plot = { x: [], y: [], t: [], tiy: 0 };
    let total_interval_y = 0.0;
    for (let i = 0; i < data.data.remaining_per_month.length; i++) {
      const date = (data.data.remaining_per_month[i].month.split('-'))
      obj_plot.x.push(`${date[1]}-${date[0]}`);
      obj_plot.y.push(parseFloat(data.data.remaining_per_month[i].total_remaining));
      obj_plot.t.push(`${parseFloat(data.data.remaining_per_month[i].total_remaining).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`);
      if (total_interval_y < parseFloat(data.data.remaining_per_month[i].total_remaining)) total_interval_y = parseFloat(data.data.remaining_per_month[i].total_remaining);
    };
    obj_plot.tiy = total_interval_y + 20000;
    setRemainingMonths(obj_plot);
  }
  console.log(remainingMonths)
  return (
    <GridContainer>
      {/*
        <GridItem xs={12} sm={6} md={2}>
          <Card>
            <div className={classes.zindex}>
              <CardHeader className="d-flex justify-content-center zindex" color="warning" stats icon>
                <CardIcon color="success">
                  <Icon>content_copy</Icon>
                </CardIcon>
              </CardHeader>
            </div>
            <CardBody className="d-flex justify-content-center">
              <p className={classes.colorCard}>Adicionar venda</p>
            </CardBody>
            <CardFooter className="d-flex justify-content-center" stats>
              <Button color="success" className={classes.margintp + " " + classes.maxwidht} onClick={() => callModalAddSell()}>
                Adicionar venda
              </Button>
            </CardFooter>
          </Card>
        </GridItem>
      */}
      <GridItem xs={12} sm={6} md={2}>
        <Card>
          <div className={classes.zindex}>
            <CardHeader className="d-flex justify-content-center zindex {classes.zindex}" color="warning" stats icon>
              <CardIcon color="warning">
                <Icon>today</Icon>
              </CardIcon>
            </CardHeader>
          </div>
          <CardBody className="d-flex justify-content-center">
            <p className={classes.colorCard}><b>Filtro</b> de data primária</p>
          </CardBody>
          <CardFooter className="d-flex justify-content-center" stats>
            <DatePicker className={classes.marginDate}
              selected={startDate}
              onChange={date => setStartDate(date.withoutTime())}
              dateFormat="dd/MM/yyyy"
              placeholderText="Digite ou clique aqui"
              locale={pt}
              disabledKeyboardNavigation />
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={2}>
        <Card>
          <div className={classes.zindex}>
            <CardHeader className="d-flex justify-content-center" color="warning" stats icon>
              <CardIcon color="warning">
                <Icon>event</Icon>
              </CardIcon>
            </CardHeader>
          </div>
          <CardBody className="d-flex justify-content-center">
            <p className={classes.colorCard}><b>Filtro</b> de data final</p>
          </CardBody>
          <CardFooter className="d-flex justify-content-center" stats>
            <DatePicker className={classes.marginDate}
              selected={endDate}
              onChange={date => setEndDate(date.withoutTime())}
              dateFormat="dd/MM/yyyy"
              placeholderText="Digite ou clique aqui"
              locale={pt}
              disabledKeyboardNavigation />
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={2}>
        <Card>
          <div className={classes.zindex}>
            <CardHeader className="d-flex justify-content-center" color="warning" stats icon>
              <CardIcon color="info">
                <Icon>analytics</Icon>
              </CardIcon>
            </CardHeader>
          </div>
          <CardBody className="d-flex justify-content-center">
            <p className={classes.colorCard}>Vendas entregues</p>
          </CardBody>
          <CardFooter className="d-flex justify-content-center" stats>
            <Switch className={classes.toogleclass} onClick={toogler} />
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={2}>
        <Card>
          <div className={classes.zindex}>
            <CardHeader className="d-flex justify-content-center" color="warning" stats icon>
              <CardIcon color="primary">
                <Icon>analytics</Icon>
              </CardIcon>
            </CardHeader>
          </div>
          <CardBody className="d-flex justify-content-center">
            <p className={classes.colorCard}>Quitadas</p>
          </CardBody>
          <CardFooter className="d-flex justify-content-center" stats>
            <Switch className={classes.toogleclass} onClick={toogler2} />
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={2}>
        <Card>
          <div className={classes.zindex}>
            <CardHeader className="d-flex justify-content-center" color="warning" stats icon>
              <CardIcon color="danger">
                <Icon>analytics</Icon>
              </CardIcon>
            </CardHeader>
          </div>
          <CardBody className="d-flex justify-content-center">
            <p className={classes.colorCard}>Vendas canceladas</p>
          </CardBody>
          <CardFooter className="d-flex justify-content-center" stats>
            <Switch className={classes.toogleclass} onClick={tooglerCancel} />
          </CardFooter>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={6} md={2}>
        <Card>
          <div className={classes.zindex}>
            <CardHeader className="d-flex justify-content-center" color="warning" stats icon>
              <CardIcon color="primary">
                <Icon>analytics</Icon>
              </CardIcon>
            </CardHeader>
          </div>
          <CardBody className="d-flex justify-content-center">
            < Box sx={{ width: '100%', height: '100%', textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Typography variant="subtitle1" sx={{}}>Total de vendas em aberto</Typography>
              <Typography variant="h6" sx={{}}>{` ${totalRemaining.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`}</Typography>
            </Box>
          </CardBody>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
        <div style={{ display: 'grid', flexDirection: 'row' }}>
          <Typography variant='subtitle1'>
            <Tooltip title="VER PAGAMENTOS">
              <IconButton onClick={() => setExpanded(!expanded)}>
                {expanded ? <ExpandLessIcon sx={{ fontSize: 35 }} /> : <ExpandMoreIcon sx={{ fontSize: 35 }} />}
              </IconButton>
            </Tooltip>
            PAGAMENTOS
          </Typography>
        </div>
        <Collapse in={expanded}>
          < Box sx={{ width: '100%', height: '600px', padding: 5, display: 'flex', flexDirection: 'row', gap: 2 }}>
            < Box sx={{ width: '60%', height: '100%' }}>
              <Plot
                data={[
                  {
                    type: 'bar',
                    x: remainingMonths.x,
                    y: remainingMonths.y,
                    type: 'bar', // Gráfico de barras
                    text: remainingMonths.t, // Formatação em moeda
                    textposition: 'outside',
                    textangle: 335,
                    marker: {
                      color: '#f55b5b', // Cor das barras
                    },
                    hoverinfo: 'skip' // Remove o balão de tooltip
                  },
                ]}
                layout={{
                  title: 'Pagamentos Faltantes por Mês',
                  xaxis: { title: 'Mês', },
                  yaxis: {
                    title: 'Saldo devedor',
                    range: [0, remainingMonths.tiy]
                  },
                  margin: { t: 50, l: 50, r: 50, b: 50 },
                  showlegend: false,
                  autosize: true
                }}
                style={{ width: '100%', height: '100%' }}
                config={{
                  displayModeBar: false, // Remove a barra de ferramentas do Plotly
                  staticPlot: true, // Desativa a interatividade completa
                  responsive: true
                }}
              />
            </Box>
            < Box sx={{ width: '40%', height: '100%', textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Typography variant="h6" sx={{}}>Total de vendas em aberto</Typography>
              <Typography variant="h4" sx={{}}>{` ${totalRemaining.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`}</Typography>
            </Box>
          </Box>

        </Collapse>
      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
        <div className={classes2.searchWrapper}>
          <CustomInput
            formControlProps={{
              className: classes2.margin + " " + classes2.search
            }}
            inputProps={{
              placeholder: "Busca por nota físcal, razão social ou nome fantasia",
              inputProps: {
                "aria-label": "Search",
                type: "text",
                value: search,
                onChange: event => setSearch(event.target.value)
              }
            }}
          />
          <Button color="white" aria-label="edit" justIcon round>
            <Search />
          </Button>
        </div>
      </GridItem>
      {sells.map(sell => (
        <TableSell key={String("Sell_" + sell[0].nf)} sell={sell} loadSell={loadSell} toogleCancel={toogleCancel} noFiscal={true} />
      ))}
      <Pagination count={totalPages} page={page} onChange={handleChange} />
      {modalShow && importModal && (
        <ModalAddSell key={String("add_" + storageId)} show={modalShow} loadSell={loadSell} onHide={() => setModalShow(false)} />
      )}
    </GridContainer>
  );

}
